import React, { useContext, useEffect, useState } from "react";
import logo from "../assets/images/logo-1.svg";
import search from "../assets/images/search.svg";
import callIcon from "../assets/images/call.svg";
import star from "../assets/images/star-m.svg";
import Dropdown from "./CustDropdown";
import { useNavigate, useLocation } from "react-router-dom";
import { API } from "../utils/api";
import { DataContext } from "../context/dataContext";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { fetchDataFromAPI } from "../utils/api";

const Header = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const dataContext = useContext(DataContext);
  const { searchKey, setSearchKey } = dataContext;
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [keyConvertToUpperCase, setKeyConvertToUpperCase] = useState("");

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]); //set size in state
    };
    // handleWindowResize()
    // console.log("screen size",windowSize)
    window.addEventListener("resize", handleWindowResize);
  }, []);

  const onSearchingHandler = (e) => {
    // console.log(e.target.value)
    e?.preventDefault();
    const val = e.target.value;
    const regexPattern = /^[A-Za-z0-9 ]*$/;
    if (regexPattern.test(val) && val.length <= 15) {
      setKeyConvertToUpperCase(val.trimStart().toUpperCase());
      setSearchKey(val.trimStart());
    }
  };

  const onSearchPrev = (e) => {
    dataContext?.setLoading(true);
    e?.preventDefault();
    API(`search/numberPlates?searchKey=${searchKey}`, "get", "", "")
      .then((res) => {
        console.log("search result res: ", res?.data);
        dataContext?.setSearchResults(res?.data);
        navigate("/search-results", { state: { searchKey: searchKey } });
        dataContext?.setLoading(false);
      })
      .catch((error) => {
        dataContext?.setLoading(false);
        console.log("search result error: ", error);
      });
  };

  const onSearch = (e) => {
    e?.preventDefault();
    if (searchKey) {
      navigate(`/search-results/${searchKey}`, {
        state: { searchKey: searchKey },
      });
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      {
        <header className="header" data-aos="fade-down">
          <div className="container">
            <nav className="navbar bg-white pt-22 pb-22">
              <div className="nav--inner d-flex justify-between w-100 align-center ">
                <a className="navbar-brand p-0" href="/">
                  <img src={logo} alt="logo" />
                </a>
                <form className="d-flex justify-between">
                  <input
                    className="form-control border-right fun f16 border-top-0 border-bottom-0 border-left-0 rounded-0 br-2 border-color f-16"
                    placeholder={
                      searchKey
                        ? ""
                        : "Search names, initials, numbers, words or anything…"
                    }
                    aria-label="Search"
                    value={searchKey}
                    onChange={onSearchingHandler}
                  />
                  <button
                    className="reg__search--button btn btn-outline-success green-section border-0 rounded-0"
                    onClick={onSearch}
                  >
                    <img className="w-30 h-30" src={search} alt="image" />
                  </button>
                </form>
                <div className="reg__header--call">
                  <div className="d-flex align-center">
                    <div className="reg__call--image text-end">
                      <img src={callIcon} alt="image" />
                    </div>
                    <div className="reg__call--details ml-10">
                      <span className="ffys f14 d-block lh20 text-blue">
                        Need some help?
                      </span>
                      <a className="f20 lh28 fsi" href="tel:01582347734">
                        01582 347734
                      </a>
                    </div>
                  </div>
                </div>
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleSidebar}
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>

              <form className="d-flex justify-between reg__mobile--search">
                <span className={searchKey ? "" : "custom-input-container"}>
                  <input
                    className="form-control border-right fun f18 border-top-0 border-bottom-0 border-left-0 rounded-0 br-2 border-color f-16"
                    aria-label="Search"
                    value={searchKey}
                    onChange={onSearchingHandler}
                  />
                </span>
                <button
                  className="reg__search--button btn btn-outline-success green-section border-0 rounded-0"
                  onClick={onSearch}
                >
                  <img className="w-30 h-30" src={search} alt="image" />
                </button>
              </form>
            </nav>
          </div>
          <div
            className={`collapse navbar-collapse header-bg ${
              isSidebarOpen ? "show" : ""
            }`}
            id="navbarSupportedContent"
          >
            <>
              {/* New */}
              <div className="d-block d-lg-none mobile_logo">
                <div className="d-flex justify-between align-center">
                  <Link
                    to={"/"}
                    onClick={toggleSidebar}
                    className="navbar-brand p-0"
                  >
                    <img
                      src={logo}
                      alt="logo"
                    />
                  </Link>

                  <div className="btn-close">
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span className="navbar-toggler-icon"></span>
                    </button>
                  </div>
                </div>
              </div>
              {/* New end */}
            </>

            <ul className="navbar-nav mr-auto flex-row justify-between pr-40 pl-40 pt-20 pb-20 fmp header-text f16 text-uppercase">
              <li className="nav-item active">
                <Link
                  className="nav-link  p-0 header-text text-300 f16 "
                  // data-bs-toggle="dropdown"
                  to={"/buy-registrations"}
                  onClick={toggleSidebar}
                >
                  Buy
                </Link>
                {/* <Link
                  className="nav-link dropdown-toggle p-0 header-text text-700 f16"
                  data-bs-toggle="dropdown"
                  to={"/sell-number-plate"}
                >
                  Sell
                </Link> */}
                {/* <Dropdown
                  items={[
                    { text: "List a Plate", link: "/sell-number-plate" },
                    {
                      text: "Get a Valuation",
                      link: "/number-plate-valuation",
                    },
                  ]}
                /> */}
              </li>
       
              <li className="nav-item">
                  <Link
                  className="nav-link  p-0 header-text text-300 f16"
                  // data-bs-toggle="dropdown"
                  to={"/sell-number-plate"}
                  onClick={toggleSidebar}
                >
                  Sell
                </Link>
              </li>
              <li className="nav-item">
                  <Link
                  className="nav-link  p-0 header-text text-300 f16"
                  // data-bs-toggle="dropdown"
                  to={"/number-plate-valuation"}
                  onClick={toggleSidebar}
                >
                  Free Valuations
                </Link>
              </li>
              <li className="nav-item">
                  <Link
                  className="nav-link  p-0 header-text text-300 f16"
                  // data-bs-toggle="dropdown"
                  to={"/buy-number-plates"}
                  onClick={toggleSidebar}
                >
                  Order Plates
                </Link>
              </li>
              <li className="nav-item">
                  <Link
                  className="nav-link  p-0 header-text text-300 f16"
                  // data-bs-toggle="dropdown"
                  to={"/plate-viewer"}
                  onClick={toggleSidebar}
                >
                  PLATE VIEWER
                </Link>
              </li>

              <li className="nav-item ">
                <Link
                  className="nav-link p-0 header-text text-300 f16"
                  to="/number-plate-news"
                  onClick={toggleSidebar}
                >
                  Blog
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link p-0 header-text text-300 f16"
                  to={"/about"}
                  onClick={toggleSidebar}
                >
                  About
                </Link>
              </li>
              {/* <li className="dropdown">
                <Link
                  className="nav-link dropdown-toggle p-0 header-text text-700 f16"
                  to=""
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Services
                </Link>
                <Dropdown
                  items={[
                    { text: "Plate Viewer", link: "/plate-viewer" },
                    {
                      text: "Plate Printing",
                      link: "/buy-number-plates",
                    },
                  ]}
                />
              </li> */}
           

              <li className="nav-item ">
                <Link
                  className="nav-link p-0 header-text text-300 f16"
                  to="/number-plate-faq"
                  onClick={toggleSidebar}
                >
                  FAQs
                </Link>
              </li>
              <li className="nav-item ">
                <Link
                  className="nav-link p-0 header-text text-300 f16"
                  to="/contact"
                  onClick={toggleSidebar}
                >
                  Contact Us
                </Link>
              </li>
              <>
                {/* New */}
                {/* <div className="mobile_footer">
                  <div className="d-flex justify-center">
                    <a
                      className="text-white f18"
                      style={{display: 'inline-block'}}
                      href="http://www.reviews.co.uk/company-reviews/store/swiftreg?utm_source=swiftreg&utm_medium=widget&utm_campaign=text-banner"
                      rel="noopener" rel="noreferrer" target="_blank">
                      <div className="d-flex align-center tetx-white flex-wrap text-center justify-center">
                        <span className="tetx-white">Our customers say</span>
                        <span className="tetx-white">Excellent</span>
                        <span className="tetx-white">
                          <img className="in-svg" src={star} alt="image" />
                          <img className="in-svg" src={star} alt="image" />
                          <img className="in-svg" src={star} alt="image" />
                          <img className="in-svg" src={star} alt="image" />
                          <img className="in-svg" src={star} alt="image" />
                        </span>
                        <div className="tetx-white f18 flex-wrap align-center d-flex justify-center">
                          <span className="tetx-white f18 mr-10 d-flex align-center flex-wrap justify-center">
                            <div className="ruk_rating mr-5 fmp text-700">
                              4.94
                            </div>
                            out of 5 based on
                            <div className="ruk_count ml-5 mr-5 fmp text-700">
                              7941
                            </div>
                            reviews
                          </span>
                          <span className="ReviewsLogo ReviewsLogo--small">
                            <img
                              src="https://assets.reviews.io/img/all-global-assets/logo/reviewsio-logo--white.svg"
                              alt="Powered By REVIEWS.io"
                              style={{width: 112}}
                            />
                          </span>
                        </div>
                      </div>
                    </a>
                  </div>
                </div> */}
                {/* New End */}
              </>
            </ul>
          </div>
        </header>
      }
    </>
  );
};

export default Header;
